import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import { IndustryOrMaterial, TypeOfTesting } from '../logic/catalog'

import { CategoryListItem } from './product/CategoryListItem'

const CardNotAllListed = () => {
  const { interpolate } = useContext(LocaleContext)

  return (
    <div className="categoryListItem categoryListItem--banner">
      <p>
        {interpolate('categoryListing.noResultsContact', {
          link: content => <a href="#askForOffer">{content}</a>,
        })}
      </p>
    </div>
  )
}

const CategoryMenu = ({
  typeOfTestingValues,
  industryOrMaterialValues,
}: {
  typeOfTestingValues: TypeOfTesting[]
  industryOrMaterialValues: IndustryOrMaterial[]
}) => {
  const { t } = useContext(LocaleContext)

  const industries = industryOrMaterialValues.sort((a, b) =>
    t(`industryOrMaterial.${a}`) > t(`industryOrMaterial.${b}`) ? 1 : -1,
  )

  const typesOfTesting = typeOfTestingValues.sort((a, b) =>
    t(`typeOfTesting.${a}`) > t(`typeOfTesting.${b}`) ? 1 : -1,
  )
  return (
    <>
      <h2 className="productListing__categoryTitle">
        {t(`productFilters.typeOfTesting.label`)}
      </h2>
      <div className="productListing__categories">
        {typesOfTesting.map(tt => (
          <CategoryListItem key={tt} categoryItem={tt} />
        ))}
        <CardNotAllListed />
      </div>
      <h2 className="productListing__categoryTitle">
        {t(`productFilters.industryOrMaterial.label`)}
      </h2>
      <div className="productListing__categories">
        {industries.map(im => (
          <CategoryListItem key={im} categoryItem={im} />
        ))}
        <CardNotAllListed />
      </div>
    </>
  )
}

export default CategoryMenu
